const Modal = require('app/ui/Modal');

const RestaurantSupplierDeliveryForm = require('app/restaurant/supplier/DeliveryForm');

class DeliveryModal {

    defaultOptions() {
        return {
            'id': window.uniqid(),
            'restaurant': null,
            'supplier': null,
            'success': function(event){},
            'onClose': function(event){},
            'onShown': function(event){},

            'onClickBack': function(modal,form){},
            'onChange': function(){},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.restaurant = this.settings.restaurant;
        if(!this.restaurant.id){
            window.notify("Missing restaurant object in SupplierDeliveryModal","danger");
        }
        this.supplier = this.settings.supplier;
        if(!this.supplier.id){
            window.notify("Missing supplier object in SupplierDeliveryModal","danger");
        }

        this.initialize();
    }

    initialize() {
        var self = this;

        this.title = window.translate('app.restaurant.show.tabs.supplier.modal.title',{'%supplierName%':this.supplier.name});
        this.subtitle= window.translate('app.restaurant.show.tabs.supplier.delivery.title');

        this.build();
    }

    build(){

        this.$content = $('<div/>')
        .addClass('restaurant-supplier-delivery-modal');

        this.modal = new Modal({
            'id': this.settings.id,
            'title': this.title,
            'subtitle': this.subtitle,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "xl",

            'onShown':this.settings.onShown,
            'onClose':this.settings.onClose,
        })

        this.buildForm();

        this.modal.show();
    }

    buildForm(){
        var self = this;
    	this.form = new RestaurantSupplierDeliveryForm({
    		'restaurant': this.restaurant,
    		'supplier': this.supplier,
            'success': this.settings.success,
            'onClickBack': function(form){
                self.settings.onClickBack(self,form);
            }
    	});

    	this.$content.append(this.form.getForm());
    }

    hasChange(){
        return this.form ? this.form.hasChange() : false;
    }

    hide(){
        this.modal.hide();
    }

    show(){
        this.modal.show();
    }

    dispose(){
        this.modal.dispose();
    }
}

module.exports = DeliveryModal;

